import React from 'react';
import { Box, xcss } from '@atlaskit/primitives';
import AppBase from '@atlassian/jira-app-base';
import { standardizeLocale } from '@atlassian/jira-common-constants/src/supported-locales';
import { useIntl } from '@atlassian/jira-intl';
import { IntlProvider } from '@atlassian/jira-intl/src/intl-provider.tsx';
import {
	ContextualAnalyticsData,
	FireScreenAnalytics,
	SCREEN,
} from '@atlassian/jira-product-analytics-bridge';
import { ServiceDeskAnalyticsContext } from '@atlassian/jira-servicedesk-analytics/src/ui/servicedesk-analytics-context/index.tsx';
import { SpaStatePageReady } from '@atlassian/jira-spa-state-controller/src/components/main.tsx';
import { Content } from './content';
import { Header } from './header';
import type { WidgetAppBaseProps, WidgetSettingsProps } from './types';

export const WidgetSettingsAppContent = (props: WidgetSettingsProps) => {
	const { projectKey, projectId } = props;
	return (
		<Box xcss={appContainerStyles}>
			<Header />
			<Content projectId={projectId} projectKey={projectKey} />
			<FireScreenAnalytics />
			<SpaStatePageReady />
		</Box>
	);
};

export const WidgetAppBase = (props: WidgetAppBaseProps) => {
	const { children, locale } = props;
	const { messages } = useIntl();

	return (
		<AppBase>
			<ServiceDeskAnalyticsContext>
				<IntlProvider locale={standardizeLocale(locale)} messages={messages}>
					<ContextualAnalyticsData sourceType={SCREEN} sourceName="widgetSettings">
						{children}
					</ContextualAnalyticsData>
				</IntlProvider>
			</ServiceDeskAnalyticsContext>
		</AppBase>
	);
};

export const WidgetSettingsApp = (props: WidgetSettingsProps) => {
	const { locale } = props;
	return (
		<WidgetAppBase locale={locale}>
			<WidgetSettingsAppContent {...props} />
		</WidgetAppBase>
	);
};

const appContainerStyles = xcss({
	paddingTop: 'space.400',
	paddingBottom: 'space.400',
});
